import styled from "styled-components";
import { device } from "./Device";
import HereColor from "../asset/pictures/hereColor1.svg";
import HereColorOnly from "../asset/pictures/hereColorOnly.svg";
import SpaceDiscover from "../asset/pictures/space_discovery1.svg";
import RocketSpace from "../asset/pictures/rocket_space.svg";
import Success1 from "../asset/pictures/success1.svg";

// *************** partie Quiz ********************
const ContainerQuiz = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 23px;
  color: white;
  text-align: center;
  position: relative;
  & h1 {
    font-family: "Oswald", sans-serif;
    font-weight: 100;
  }
  & h2 {
    font-family: "Allerta Stencil";
    color: #f24b4b;
    font-size: 30px;
    font-weight: 100;
  }
  & p {
    font-family: "Allerta Stencil";
    color: #f24b4b;
  }
  & h1,
  h2 {
    margin: 10px;
    @media ${device.tablet} {
      font-size: 17px;
    }
  }
`;

const BackgroundStart = styled(ContainerQuiz)`
  background: url(${HereColor}) no-repeat 20% 60%;
  background-size: 76em;
  @media ${device.laptop} {
    background: url(${HereColorOnly}) no-repeat 52% 97%;
    background-size: 33em;
  }
  @media ${device.mobileL} {
    background-size: 15em;
  }

  & img {
    @media ${device.tablet} {
      width: 13em;
    }
  }
`;

const BackgroundNext = styled(ContainerQuiz)`
  background: url(${SpaceDiscover}) no-repeat 50%;
  background-attachment: scroll;
  background-size: 55em;
  background-color: #363f59;
  @media ${device.tablet} {
    background-size: 22em;
  }
`;

const BtnStart = styled.button`
  font-family: "Allerta Stencil";
  color: white;
  background-color: #363f59;
  padding: 10px 50px;
  text-transform: uppercase;
  font-size: 18px;
  margin-top: 20px;
  cursor: pointer;
  position: absolute;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.8);
  border-radius: 22px;
  outline: inherit;

  @media ${device.tablet} {
    font-size: 15px;
    padding: 7px 30px;
  }

  &:hover {
    color: #f24b4b;
    background-color: white;
  }
`;

const BtnNext = styled(BtnStart)`
  position: inherit;
  color: white;
  background-color: ${(props) => props.backgroundColor || "#f24b4b"};
  border-radius: 7px;

  &:hover {
    color: #f24b4b;
  }
`;

const NoMatch = styled(ContainerQuiz)`
  background: url(${RocketSpace}) no-repeat 52% 19%;
  background-attachment: scroll;
  background-size: 30em;
  @media ${device.tablet} {
    background-position: 42% 6%;
    background-size: 25em;
  }

  & h2,
  p {
    font-family: "Allerta Stencil";
    color: #363f59;
  }
`;

const Match = styled(ContainerQuiz)`
  background: url(${Success1}) no-repeat 50% 90%;
  background-size: 100em;
`;

const Error = styled.div`
  font-family: "Oswald", sans-serif;
  color: #f24b4b;

  @media ${device.tablet} {
    font-size: 15px;
  }
`;
const AnswerQuestionnary = styled.button`
  font-family: "Oswald", sans-serif;
  border: 1px solid #363f59;
  padding: 5px 10px 5px 45px;
  width: 80%;
  max-width: 610px;
  text-align: left;
  margin-top: 10px;
  position: relative;
  font-size: 22px;
  cursor: pointer;
  transition: ease-in-out 0.15s;
  background-color: white;
  border-radius: 22px;

  &:hover {
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.8);
    color: #f24b4b;
    background-color: #363f59;
  }
  &:focus {
    outline: none;
  }
  @media ${device.tablet} {
    font-size: 15px;
  }
`;
const AnswerQuestionnarySelected = styled(AnswerQuestionnary)`
  color: #363f59;
  background-color: #f24b4b;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.8);
  &:hover {
    background-color: #f24b4b;
    color: #363f59;
  }
`;
const Letter = styled.span`
  font-family: "Oswald", sans-serif;
  color: seagreen;
  width: 30px;
  position: absolute;
  left: 0;
  text-align: center;
  height: 28px;
  top: 0;
  padding: 5px 5px 5px 15px;
  text-transform: uppercase;
`;
export {
  ContainerQuiz,
  BackgroundStart,
  BackgroundNext,
  BtnStart,
  BtnNext,
  Match,
  NoMatch,
  Error,
  AnswerQuestionnary,
  AnswerQuestionnarySelected,
  Letter,
};
